<div @fadeInOut *ngIf="(runningWholesaler$ | async)?.id"
     [ngClass]="{
       success: (runningResult$ | async) === RunningResultEnum.Success,
       error: (runningResult$ | async) === RunningResultEnum.Failed
     }"
     class="running-integration-message"
>
  <img *ngIf="(runningResult$ | async) === undefined"
       class="message-icon animation-infinite-rotating"
       src="assets/icons/icon-loading-white.svg"
       alt="loading"
  />
  <img *ngIf="(runningResult$ | async) === RunningResultEnum.Success"
       class="message-icon"
       src="assets/icons/icon-success-circle-white.svg"
       alt="loading"
  />
  <img *ngIf="(runningResult$ | async) === RunningResultEnum.Failed"
       class="message-icon"
       src="assets/icons/icon-danger-circle-white.svg"
       alt="loading"
  />

  <div class="content">
    <div *ngIf="(runningResult$ | async) === undefined" class="message-header">Running integration...</div>
    <div *ngIf="(runningResult$ | async) === RunningResultEnum.Success" class="message-header">Success!</div>
    <div *ngIf="(runningResult$ | async) === RunningResultEnum.Failed" class="message-header">Unable to run</div>

    <div *ngIf="(runningResult$ | async) === undefined" class="message-text">
      Wholesaler integration with {{(runningWholesaler$ | async)?.wholesalerName}} is underway.
      You may continue to use the system in the meantime
    </div>
    <div *ngIf="(runningResult$ | async) === RunningResultEnum.Success" class="message-text">
      Completed a successful integration run with {{(runningWholesaler$ | async)?.wholesalerName}}
    </div>
    <div *ngIf="(runningResult$ | async) === RunningResultEnum.Failed" class="message-text">
      An error was encountered while trying to process order files. Please try again later.
    </div>
  </div>

  <img (click)="closeRunningWholesalerDialog()"
       class="close-icon animation-focus-default"
       src="assets/icons/icon-close-white.svg"
       alt="close"
  />
</div>
